/** Auto-generated fallback messages from /locale/en/*.json */
export const fallbackMessages: Record<string, string> = {
  'core.appointment.messages.rescheduledCountTimes': 'Rescheduled {count} times',
  'core.appointment.messages.rescheduledOnce': 'Rescheduled once',
  'core.appointment.messages.rescheduledTwice': 'Rescheduled twice',
  'core.customFields.descriptions.dateAndTimeFields': 'Date and time fields',
  'core.customFields.descriptions.emailAddressInputField': 'Email address input field',
  'core.customFields.descriptions.format1XxxXxxXxxx': 'Format +1(XXX) XXX-XXXX',
  'core.customFields.descriptions.formatMmDdYyyy': 'Format MM/DD/YYYY',
  'core.customFields.descriptions.linkToTheFormFeatures': 'Link to the form features',
  'core.customFields.descriptions.multipleFileUploadField': 'Multiple file upload field',
  'core.customFields.descriptions.numericInputField': ' Numeric input field',
  'core.customFields.descriptions.openTextFieldMultipleLines': 'Open text field, multiple lines',
  'core.customFields.descriptions.openTextFieldSingleLine': 'Open text field, single line',
  'core.customFields.descriptions.selectMultipleOptionsFromAList':
    'Select multiple options from a list',
  'core.customFields.descriptions.selectOneOptionFromAList': 'Select one option from a list',
  'core.customFields.descriptions.singleFileUploadField': 'Single file upload field',
  'core.customFields.descriptions.singleOptionDropDownListOpenTextField':
    'Single option drop-down list + open text field',
  'core.customFields.descriptions.toggleButton': 'Toggle Button',
  'core.customFields.labels.comboBox': 'Combo Box',
  'core.customFields.labels.date': 'Date',
  'core.customFields.labels.dropDownMultiSelectList': 'Drop-down Multi Select List',
  'core.customFields.labels.dropDownSingleSelectList': 'Drop-down Single Select List',
  'core.customFields.labels.eMail': 'E-mail',
  'core.customFields.labels.featureLink': 'Feature Link',
  'core.customFields.labels.multiDocument': 'Multi Document',
  'core.customFields.labels.number': 'Number',
  'core.customFields.labels.phone': 'Phone',
  'core.customFields.labels.singleDocument': 'Single Document',
  'core.customFields.labels.textMultipleLines': 'Text - Multiple Lines',
  'core.customFields.labels.textSingleLine': 'Text - Single Line',
  'core.customFields.labels.timestamp': 'Timestamp',
  'core.customFields.labels.trueFalse': 'True/False',
  'core.customFields.select_date': 'Select date',
  'core.customForms.customFormsFeaturesData.descriptions.appointmentCheckOutForm':
    'Appointment check-out form',
  'core.customForms.customFormsFeaturesData.descriptions.captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals':
    'Capture check-in details from drivers for both planned and unplanned arrivals.',
  'core.customForms.customFormsFeaturesData.descriptions.captureCheckOutDataAfterAnAppointmentIsCompleted':
    'Capture check-out data after an appointment is completed.',
  'core.customForms.customFormsFeaturesData.descriptions.captureLoadTypeSpecificDetailsDuringAppointmentScheduling':
    'Capture load type specific details during appointment scheduling.',
  'core.customForms.customFormsFeaturesData.descriptions.claimTrackingForm': 'Claim tracking form',
  'core.customForms.customFormsFeaturesData.descriptions.collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution':
    'Collect driver info as they self check-in for their planned appointment. This feature is an optional add-on to our Gate Management solution.',
  'core.customForms.customFormsFeaturesData.descriptions.documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad':
    'Document damage, discrepancies or other issues related to the received load.',
  'core.customForms.customFormsFeaturesData.descriptions.documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad':
    'Document load integrity and other security measures related to the shipped load.',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn':
    'Enable the Gate Management module for this warehouse, which includes the check-in',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheIdValidationForThisWarehouse':
    'Enable the ID Validation module for this warehouse.',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheSmartGateModuleForThisWarehouse':
    'Enable the SmartGate module for this warehouse.',
  'core.customForms.customFormsFeaturesData.descriptions.enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp':
    'Enable the YMS module for this warehouse, also enable the asset visit fields for the gate management app.',
  'core.customForms.customFormsFeaturesData.descriptions.enterTheWeightOfTheCargo':
    'Enter the weight of the cargo',
  'core.customForms.customFormsFeaturesData.descriptions.inboundClaimEvidenceForm':
    'Inbound Claim Evidence Form',
  'core.customForms.customFormsFeaturesData.descriptions.informIfTheLoadHasPassedTheSecurityCheck':
    'Inform if the load has passed the security check',
  'core.customForms.customFormsFeaturesData.descriptions.outboundClaimEvidenceForm':
    'Outbound Claim Evidence Form',
  'core.customForms.customFormsFeaturesData.descriptions.pleaseFillOutTheRequiredInformationIfYouWantToConfirmTheCheckOutForThisAppointment':
    'Please fill out the required information if you want to confirm the check-out for this appointment',
  'core.customForms.customFormsFeaturesData.descriptions.pleaseFillOutThisFormToDocumentDamageOrOtherIssuesRelatedToTheReceivedLoad':
    'Please fill out this form to document damage or other issues related to the received load',
  'core.customForms.customFormsFeaturesData.descriptions.pleaseFillOutThisFormToDocumentSecurityDetailsOrOtherEvidenceRelatedToTheShippedLoad':
    'Please fill out this form to document security details or other evidence related to the shipped load',
  'core.customForms.customFormsFeaturesData.descriptions.provideMoreInformationAboutTheIdentifiedDamageSuchAsExtentAndAffectedAreas':
    'Provide more information about the identified damage, such as extent and affected areas',
  'core.customForms.customFormsFeaturesData.descriptions.provideMoreInformationAboutTheIdentifiedDiscrepancySuchAsTheQuantityDifferenceAndMissingItems':
    'Provide more information about the identified discrepancy, such as the quantity difference and missing items',
  'core.customForms.customFormsFeaturesData.descriptions.provideMoreInformationOnHowTheLoadWasSecuredTheOverallIntegrityAndOtherHandlingPrecautionsTaken':
    'Provide more information on how the load was secured, the overall integrity and other handling precautions taken',
  'core.customForms.customFormsFeaturesData.descriptions.reviewAndManageAppointmentDataAfterCompletion':
    'Review and manage appointment data after completion.',
  'core.customForms.customFormsFeaturesData.descriptions.selectOneOrMoreOptionsThatBestIdentifyTheTypeOfDamage':
    'Select one or more options that best identify the type of damage',
  'core.customForms.customFormsFeaturesData.descriptions.selectOneOrMoreTypesOfDiscrepancyObservedInTheReceivedLoad':
    'Select one or more types of discrepancy observed in the received load',
  'core.customForms.customFormsFeaturesData.descriptions.storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard':
    'Store and track details of trailers and containers as they arrive at your yard.',
  'core.customForms.customFormsFeaturesData.descriptions.uploadEvidencesOfTheCheckOutEvent':
    'Upload evidences of the check-out event',
  'core.customForms.customFormsFeaturesData.descriptions.uploadPhotosDocumentsOrAnyEvidenceOfTheIdentifiedDiscrepancy':
    'Upload photos, documents or any evidence of the identified discrepancy',
  'core.customForms.customFormsFeaturesData.descriptions.uploadPhotosOfOverallConditionArrangementAndSecurityOfTheLoadAndTrailer':
    'Upload photos of overall condition, arrangement, and security of the load and trailer',
  'core.customForms.customFormsFeaturesData.descriptions.uploadPhotosOfTheSealsToDocumentTheirIntegrityAndProperPlacement':
    'Upload photos of the seals to document their integrity and proper placement',
  'core.customForms.customFormsFeaturesData.descriptions.uploadPhotosOrAnyEvidenceOfTheIdentifiedDamage':
    'Upload photos or any evidence of the identified damage',
  'core.customForms.customFormsFeaturesData.disableDisclaimers.allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime':
    'All Fields on this form will be <strong>unavailable</strong> during appointment scheduling.<br />You can re-enable this form at any time.',
  'core.customForms.customFormsFeaturesData.disableDisclaimers.theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn':
    'The drivers will not see this form when they are checking themselves in.',
  'core.customForms.customFormsFeaturesData.dropdownValues.brokenOrLooseSeal':
    'Broken or Loose Seal',
  'core.customForms.customFormsFeaturesData.dropdownValues.brokenPalletsCrates':
    'Broken Pallets/Crates',
  'core.customForms.customFormsFeaturesData.dropdownValues.concealedDamage': 'Concealed Damage',
  'core.customForms.customFormsFeaturesData.dropdownValues.contaminationParasitesMoldSmell':
    'Contamination(parasites, mold, smell)',
  'core.customForms.customFormsFeaturesData.dropdownValues.damageToTrailer': 'Damage to Trailer',
  'core.customForms.customFormsFeaturesData.dropdownValues.incorrectDelivery': 'Incorrect Delivery',
  'core.customForms.customFormsFeaturesData.dropdownValues.incorrectPalletization':
    'Incorrect Palletization',
  'core.customForms.customFormsFeaturesData.dropdownValues.incorrectSku': 'Incorrect SKU',
  'core.customForms.customFormsFeaturesData.dropdownValues.loss': 'Loss',
  'core.customForms.customFormsFeaturesData.dropdownValues.missingOrIncorrectDocumentation':
    'Missing or Incorrect Documentation',
  'core.customForms.customFormsFeaturesData.dropdownValues.missingOrIncorrectLabel':
    'Missing or Incorrect Label',
  'core.customForms.customFormsFeaturesData.dropdownValues.noDamage': 'No Damage',
  'core.customForms.customFormsFeaturesData.dropdownValues.noDiscrepancy': 'No Discrepancy',
  'core.customForms.customFormsFeaturesData.dropdownValues.overage': 'Overage',
  'core.customForms.customFormsFeaturesData.dropdownValues.packagingDamage': 'Packaging Damage',
  'core.customForms.customFormsFeaturesData.dropdownValues.packagingDiscrepancyWrongTypeOrSize':
    'Packaging Discrepancy (wrong type or size)',
  'core.customForms.customFormsFeaturesData.dropdownValues.shortage': 'Shortage',
  'core.customForms.customFormsFeaturesData.dropdownValues.spillsAndLeaks': 'Spills and Leaks',
  'core.customForms.customFormsFeaturesData.dropdownValues.temperatureRelatedDamage':
    'Temperature-Related Damage',
  'core.customForms.customFormsFeaturesData.dropdownValues.unsecuredOrShiftedLoad':
    'Unsecured or Shifted Load',
  'core.customForms.customFormsFeaturesData.dropdownValues.visibleDamage': 'Visible Damage',
  'core.customForms.customFormsFeaturesData.dropdownValues.wrongItemShipped': 'Wrong Item Shipped',
  'core.customForms.customFormsFeaturesData.enableDisclaimers.allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling':
    'All Fields on this form will be <strong>available and visible</strong> during appointment scheduling.',
  'core.customForms.customFormsFeaturesData.enableDisclaimers.theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn':
    'The drivers will see this form when they are checking themselves in.',
  'core.customForms.customFormsFeaturesData.helpLinks.learnHowItWorks':
    '<a href="https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In" target="_blank">Learn how it works.</a>',
  'core.customForms.customFormsFeaturesData.helpLinks.learnHowItWorksOrContactUsToRequestATrial':
    '<a href="https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In" target="_blank">Learn how it works</a> or contact us to <a href="https://lp.opendock.com/gate-management" target="_blank">request a trial.</a>.',
  'core.customForms.customFormsFeaturesData.labels.BOL': 'BOL',
  'core.customForms.customFormsFeaturesData.labels.checkOutDamage': 'Check-out Damage?',
  'core.customForms.customFormsFeaturesData.labels.checkOutDocument': 'Check-out Document',
  'core.customForms.customFormsFeaturesData.labels.checkOutForm': 'Check-out Form',
  'core.customForms.customFormsFeaturesData.labels.checkOutTime': 'Check-out Time',
  'core.customForms.customFormsFeaturesData.labels.checkOutWeight': 'Check-out Weight',
  'core.customForms.customFormsFeaturesData.labels.claimsForm': 'Claims Form',
  'core.customForms.customFormsFeaturesData.labels.claimsSupportFormsCanAlsoBeUpdatedDirectlyFromTheClaimsSupportTab':
    'Claims Support forms can also be updated directly from the Claims Support tab',
  'core.customForms.customFormsFeaturesData.labels.damageDescription': 'Damage Description',
  'core.customForms.customFormsFeaturesData.labels.damagePhotos': 'Damage Photos',
  'core.customForms.customFormsFeaturesData.labels.damageType': 'Damage Type',
  'core.customForms.customFormsFeaturesData.labels.discrepancyDescription':
    'Discrepancy Description',
  'core.customForms.customFormsFeaturesData.labels.discrepancyPhotos': 'Discrepancy Photos',
  'core.customForms.customFormsFeaturesData.labels.discrepancyType': 'Discrepancy Type',
  'core.customForms.customFormsFeaturesData.labels.inboundClaimEvidenceForm':
    'Inbound Claim Evidence Form',
  'core.customForms.customFormsFeaturesData.labels.loadIntegrityPhotos': 'Load Integrity Photos',
  'core.customForms.customFormsFeaturesData.labels.loadSecurityChecked': 'Load Security Checked',
  'core.customForms.customFormsFeaturesData.labels.loadSecurityDescription':
    'Load Security Description',
  'core.customForms.customFormsFeaturesData.labels.outboundClaimEvidenceForm':
    'Outbound Claim Evidence Form',
  'core.customForms.customFormsFeaturesData.labels.receivedLoadInspection':
    'Received Load Inspection',
  'core.customForms.customFormsFeaturesData.labels.sealIntegrityPhotos': 'Seal Integrity Photos',
  'core.customForms.customFormsFeaturesData.labels.selectAClaimsSupportToUpdate':
    'Select a Claims Support to update',
  'core.customForms.customFormsFeaturesData.labels.shippedLoadVerification':
    'Shipped Load Verification',
  'core.customForms.customFormsFeaturesData.labels.updateClaimsSupport': 'Update Claims Support',
  'core.customForms.customFormsFeaturesData.placeholders.enterDetailsAndObservationsAboutTheDamage':
    'Enter details and observations about the damage',
  'core.customForms.customFormsFeaturesData.placeholders.enterDetailsAndObservationsAboutTheDiscrepancy':
    'Enter details and observations about the discrepancy',
  'core.customForms.customFormsFeaturesData.placeholders.enterDetailsOnLoadSecuringMeasuresAndOtherObservations':
    'Enter details on load securing measures and other observations',
  'core.customForms.customFormsFeaturesData.subtitles.phoneNumberAndCarrierCompanyWillBeCollectedByDefault':
    '<strong>Phone number</strong> and <strong>carrier company</strong> will be collected by default',
  'core.customForms.customFormsFeaturesData.titles.appointmentCompleted': 'Appointment Completed',
  'core.customForms.customFormsFeaturesData.titles.appointmentsPerLoadType':
    'Appointments per Load Type',
  'core.customForms.customFormsFeaturesData.titles.assetDetails': 'Asset Details',
  'core.customForms.customFormsFeaturesData.titles.checkIn': 'Check-in',
  'core.customForms.customFormsFeaturesData.titles.checkInDeprecated': 'Check-in (Deprecated)',
  'core.customForms.customFormsFeaturesData.titles.checkOut': 'Check-Out',
  'core.customForms.customFormsFeaturesData.titles.gateManagement': 'Gate Management',
  'core.customForms.customFormsFeaturesData.titles.idValidation': 'ID Validation',
  'core.customForms.customFormsFeaturesData.titles.receivedLoadInspection':
    'Received Load Inspection',
  'core.customForms.customFormsFeaturesData.titles.shippedLoadVerification':
    'Shipped Load Verification',
  'core.customForms.customFormsFeaturesData.titles.smartGateIntegration': 'SmartGate integration',
  'core.customForms.customFormsFeaturesData.titles.yardManagementSystem': 'Yard Management System',
  'core.global.address.autocomplete.incomplete':
    'The selected address is incomplete, please fill-in the address manually.',
  'core.global.entities.appointments': 'Appointment | Appointments',
  'core.global.entities.companies': 'Company | Companies',
  'core.global.entities.docks': 'Dock | Docks',
  'core.global.entities.loadTypes': 'Load Type | Load Types',
  'core.global.entities.organizations': 'Organization | Organizations',
  'core.global.entities.orgs': 'Org | Orgs',
  'core.global.entities.users': 'User | Users',
  'core.global.entities.warehouses': 'Warehouse | Warehouses',
  'core.idVerificationChecks.id_account_comparison.face_mismatch':
    'Face is inconsistent with the selfie found on the account.',
  'core.idVerificationChecks.id_account_comparison.names_swapped':
    'The claimed first name matches the extracted last name and vice versa.',
  'core.idVerificationChecks.id_account_comparison.property_conflict':
    'ID properties are inconsistent with the account details.',
  'core.idVerificationChecks.id_age_comparison.failed_requirement':
    'ID details do not meet age requirements.',
  'core.idVerificationChecks.id_age_inconsistency_detection.inconsistent_age':
    'The age listed on the ID appears to be different than the age estimated from the face portrait.',
  'core.idVerificationChecks.id_attribute_comparison.property_conflict':
    'ID properties are inconsistent with the provided values.',
  'core.idVerificationChecks.id_barcode_detection.back_missing':
    'Unsuccessful detection of the back of the ID.',
  'core.idVerificationChecks.id_barcode_detection.barcode_not_decoded':
    'The barcode on the ID cannot be decoded.',
  'core.idVerificationChecks.id_barcode_detection.barcode_not_detected':
    'The barcode on the ID is not found.',
  'core.idVerificationChecks.id_barcode_inconsistency_detection.field_invalid':
    'The barcode has fields in invalid formats.',
  'core.idVerificationChecks.id_barcode_inconsistency_detection.format_invalid':
    'The barcode does not follow ID specifications.',
  'core.idVerificationChecks.id_barcode_inconsistency_detection.issuer_invalid':
    'The barcode specifies an issuer that is invalid.',
  'core.idVerificationChecks.id_barcode_inconsistency_detection.issuer_mismatch':
    'The barcode has inconsistent issuer information.',
  'core.idVerificationChecks.id_barcode_inconsistency_detection.metadata_invalid':
    'Barcode metadata is inconsistent with genuine IDs from the provided issuer.',
  'core.idVerificationChecks.id_barcode_inconsistency_detection.required_field_missing':
    'The barcode is missing required fields.',
  'core.idVerificationChecks.id_barcode_inconsistency_detection.revision_invalid':
    'Barcode revision is inconsistent with genuine IDs from the provided issuer.',
  'core.idVerificationChecks.id_blur_detection.too_blurry': 'The submission is blurry.',
  'core.idVerificationChecks.id_color_inconsistency_detection.image_is_monochrome':
    'The colors detected on the ID appear to be monochromatic.',
  'core.idVerificationChecks.id_compromised_detection.fraudulent':
    'The ID is reported as fraudulent.',
  'core.idVerificationChecks.id_compromised_detection.publicly_available':
    'The ID is likely a sample ID or publicly available.',
  'core.idVerificationChecks.id_compromised_detection.sample_document':
    'The ID contains a word that indicates it is a sample.',
  'core.idVerificationChecks.id_corner_detection.insufficient_padding':
    'The ID is too close to the edge of the image.',
  'core.idVerificationChecks.id_damaged_detection.defect_detected':
    'Clipped corners, cracks, or torn edges were detected on the ID.',
  'core.idVerificationChecks.id_damaged_detection.holepunch_detected':
    'A holepunch was detected on the ID.',
  'core.idVerificationChecks.id_disallowed_country_detection.no_country':
    'No country was extracted.',
  'core.idVerificationChecks.id_disallowed_country_detection.not_allowed_by_configuration':
    'The country of the ID is not allowed based on template requirements.',
  'core.idVerificationChecks.id_disallowed_country_detection.selected_country_mismatch':
    'The country of the ID does not match the country selected by the user.',
  'core.idVerificationChecks.id_disallowed_type_detection.disallowed_designation':
    'The ID has a designation that is not allowed based on template requirements.',
  'core.idVerificationChecks.id_disallowed_type_detection.not_allowed_by_configuration':
    'The ID type is not allowed based on template requirements.',
  'core.idVerificationChecks.id_disallowed_type_detection.restricted_type':
    'The ID type cannot be collected due to federal compliance requirements.',
  'core.idVerificationChecks.id_disallowed_type_detection.type_mismatch':
    'The ID type detected does not match the ID type the user selected.',
  'core.idVerificationChecks.id_disallowed_type_detection.type_not_detected':
    'The ID type of the submission could not be identified.',
  'core.idVerificationChecks.id_double_side_detection.side_submitted_twice':
    'The back and front submissions of the ID are of the same side.',
  'core.idVerificationChecks.id_electronic_replica_detection.digital_text_found':
    'The submission may contain digital text which is often found on a replica.',
  'core.idVerificationChecks.id_electronic_replica_detection.emulator_detected':
    'The submission may have been submitted on an emulator.',
  'core.idVerificationChecks.id_electronic_replica_detection.photocopy_found':
    'The submission may be a replica of a photocopy.',
  'core.idVerificationChecks.id_electronic_replica_detection.replica_detected':
    'The submission may be a generic replica.',
  'core.idVerificationChecks.id_electronic_replica_detection.rooted_device':
    'The submission may have been submitted on a rooted device.',
  'core.idVerificationChecks.id_electronic_replica_detection.screenshot_found':
    'The submission may be a replica of a screenshot.',
  'core.idVerificationChecks.id_electronic_replica_detection.virtual_camera_detected':
    'The submission may have been submitted using a virtual camera.',
  'core.idVerificationChecks.id_entity_detection.cannot_verify_id':
    'This submission does not appear to include a government ID.',
  'core.idVerificationChecks.id_expired_detection.expired': 'The ID is expired.',
  'core.idVerificationChecks.id_extracted_properties_detection.name_partially_extracted':
    'First name and last name were required, but only one was extracted.',
  'core.idVerificationChecks.id_extracted_properties_detection.property_not_extracted':
    'Required ID field(s) were not extracted.',
  'core.idVerificationChecks.id_extracted_properties_detection.required_properties_absent_on_id':
    'The missing required properties are not present on the ID.',
  'core.idVerificationChecks.id_extraction_inconsistency_detection.property_mismatch':
    'Details extracted from the front of the ID are different than the details extracted from the barcode.',
  'core.idVerificationChecks.id_fabrication_detection.camouflage_passport':
    'The submitted ID is issued by an unrecognized or invalid government entity.',
  'core.idVerificationChecks.id_fabrication_detection.fabricated_id_version':
    'The submitted ID does not match a known in-circulation format of that ID type.',
  'core.idVerificationChecks.id_glare_detection.too_much_glare': 'The submission has glare.',
  'core.idVerificationChecks.id_inconsistent_repeat_detection.inconsistent_details':
    'The face portrait matches that of a previously submitted ID with different text attributes.',
  'core.idVerificationChecks.id_inconsistent_repeat_detection.inconsistent_face':
    'The ID text attributes match that of a previously submitted ID with a different face portrait.',
  'core.idVerificationChecks.id_inquiry_comparison.names_swapped':
    'The claimed first name matches the extracted last name and vice versa.',
  'core.idVerificationChecks.id_inquiry_comparison.property_conflict':
    'ID details like name or birthdate are inconsistent between different submission attempts.',
  'core.idVerificationChecks.id_mrz_detection.mrz_incomplete':
    'The full area of the encoded, machine-readable text on the ID was not detected.',
  'core.idVerificationChecks.id_mrz_detection.mrz_not_found':
    'The encoded, machine-readable text on the ID is not found.',
  'core.idVerificationChecks.id_mrz_inconsistency_detection.mrz_checksum_invalid':
    'The encoded, machine-readable text on the ID has invalid checksum(s).',
  'core.idVerificationChecks.id_number_format_inconsistency_detection.incorrect_format':
    'The ID number has an invalid format.',
  'core.idVerificationChecks.id_number_format_inconsistency_detection.invalid_checksum':
    'The ID number has an invalid checksum.',
  'core.idVerificationChecks.id_number_format_inconsistency_detection.invalid_encoded_data':
    'Data encoded in the ID number does not match data extracted from the ID.',
  'core.idVerificationChecks.id_paper_detection.paper_id_detected':
    'The submitted ID is printed on a piece of paper.',
  'core.idVerificationChecks.id_physical_tamper_detection.tamper_detected':
    'The submission appears to have been tampered physically.',
  'core.idVerificationChecks.id_po_box_detection.address_is_hc_box': 'The address is a HC box.',
  'core.idVerificationChecks.id_po_box_detection.address_is_po_box': 'The address is a PO box.',
  'core.idVerificationChecks.id_portrait_clarity_detection.portrait_not_clear':
    'The face portrait is unclear and out of focus.',
  'core.idVerificationChecks.id_portrait_detection.portrait_not_found':
    'The submission has no face portrait.',
  'core.idVerificationChecks.id_public_figure_detection.public_figure_detected':
    'The face portrait appears to match that of a known public figure.',
  'core.idVerificationChecks.id_real_id_detection.federal_limits_apply':
    'ID does not meet federal guidelines for REAL Enhanced IDs.',
  'core.idVerificationChecks.id_real_id_detection.federal_limits_undetected':
    "ID's compliance type could not be detected.",
  'core.idVerificationChecks.id_repeat_detection.details_only_repeat':
    'The ID details match that of a previously submitted ID on a different account.',
  'core.idVerificationChecks.id_repeat_detection.repeat':
    'The ID details and face portrait match that of a previously submitted ID on a different account.',
  'core.idVerificationChecks.id_selfie_comparison.face_mismatch':
    'The face portrait on the ID and the selfie appear to be different faces.',
  'core.idVerificationChecks.id_tamper_detection.exif_inconsistency':
    'The submission has inconsistencies in the file metadata.',
  'core.idVerificationChecks.id_tamper_detection.image_manipulated':
    'The submission appears to have been tampered by an editor.',
  'core.idVerificationChecks.id_tamper_detection.portrait_tampering':
    'The submission appears to have a tampered portrait.',
  'core.idVerificationChecks.id_unprocessable_submission_detection.age_below_limit':
    'The age detected in the portrait is below the processable age limit.',
  'core.idVerificationChecks.id_unprocessable_submission_detection.submission_invalid':
    'The submission is unprocessable.',
  'core.idVerificationChecks.id_valid_dates_detection.issuer_rules_inconsistency':
    'The dates on the ID appear to be in violation of issuing authority rules.',
  'core.idVerificationChecks.id_video_quality_detection.corrupt': 'The video is corrupt.',
  'core.idVerificationChecks.id_video_quality_detection.duration_too_short':
    'The duration of the video was too short.',
  'core.idVerificationChecks.id_video_quality_detection.low_bit_rate': 'The bit rate is too low.',
  'core.idVerificationChecks.id_video_quality_detection.low_frame_rate':
    'The frame rate is too low.',
  'core.idVerificationChecks.id_video_quality_detection.not_found': 'There was no video uploaded.',
  'core.idVerificationChecks.selfie_account_comparison.face_mismatch':
    'The selfie is inconsistent with the portrait on the account.',
  'core.idVerificationChecks.selfie_age_comparison.age_above_limit':
    'The age range detected in the selfie is above the age limit.',
  'core.idVerificationChecks.selfie_age_comparison.age_below_limit':
    'The age range detected in the selfie is below the age limit.',
  'core.idVerificationChecks.selfie_age_comparison.age_mismatch':
    'The reference age falls outside of the age range detected in the selfie.',
  'core.idVerificationChecks.selfie_age_threshold_comparison.age_outside_limits':
    'The age range detected in the selfie falls outside of configured age limits.',
  'core.idVerificationChecks.selfie_age_threshold_comparison.no_selfie_age_prediction':
    'No perceived age prediction was available from the selfie.',
  'core.idVerificationChecks.selfie_attribute_comparison.face_mismatch':
    'The selfie is inconsistent with the provided selfies.',
  'core.idVerificationChecks.selfie_face_covering_detection.face_covering_detected':
    'The selfie contains a person with a PPE face covering.',
  'core.idVerificationChecks.selfie_glasses_detection.glasses':
    'Glasses are detected and may interfere with selfie face detection.',
  'core.idVerificationChecks.selfie_glasses_detection.sunglasses':
    'Sunglasses are detected and may interfere with selfie face detection.',
  'core.idVerificationChecks.selfie_id_comparison.comparison_attempt_unsuccessful':
    'An error has occurred that made the selfie and government ID comparison attempt fail.',
  'core.idVerificationChecks.selfie_id_comparison.face_mismatch':
    'The selfie and the face portrait in the ID appear to be different faces.',
  'core.idVerificationChecks.selfie_image_quality_detection.excessive_illumination':
    'The submission is too excessively lit.',
  'core.idVerificationChecks.selfie_image_quality_detection.insufficient_detail':
    'Camera resolution or image detail is too low.',
  'core.idVerificationChecks.selfie_image_quality_detection.insufficient_illumination':
    'The submission has insufficient lighting.',
  'core.idVerificationChecks.selfie_liveness_detection.deepfake_detected':
    'The selfie appears to be a deepfake.',
  'core.idVerificationChecks.selfie_liveness_detection.device_detected':
    'The selfie does not appear to be a live person.',
  'core.idVerificationChecks.selfie_liveness_detection.emulator_detected':
    'The submission may have been submitted on an emulator.',
  'core.idVerificationChecks.selfie_liveness_detection.gen_ai_detected':
    'The selfie appears to be an AI generated image.',
  'core.idVerificationChecks.selfie_liveness_detection.invalid_pose':
    'Failed to determine selfie liveness due to inadequate image quality.',
  'core.idVerificationChecks.selfie_liveness_detection.replica_2d_detected':
    'The selfie appears to be a 2d replica.',
  'core.idVerificationChecks.selfie_liveness_detection.replica_detected':
    'The selfie has characteristics that are indicative of a spoof.',
  'core.idVerificationChecks.selfie_liveness_detection.rooted_device':
    'The images may have been submitted on a rooted device.',
  'core.idVerificationChecks.selfie_liveness_detection.unexpected_orientation':
    'The submission is not properly oriented.',
  'core.idVerificationChecks.selfie_liveness_detection.virtual_camera_detected':
    'The selfie has characteristics that are indicative of virtual camera usage.',
  'core.idVerificationChecks.selfie_multiple_faces_detection.face_conflict':
    'The selfies appear to be different faces across poses.',
  'core.idVerificationChecks.selfie_multiple_faces_detection.multiple_faces_detected':
    'The selfie has multiple faces in the frame.',
  'core.idVerificationChecks.selfie_portrait_quality_detection.eyes_closed':
    'The face portrait appears to have closed eyes.',
  'core.idVerificationChecks.selfie_portrait_quality_detection.missing_face':
    'The selfie has no face.',
  'core.idVerificationChecks.selfie_portrait_quality_detection.portrait_not_clear':
    'The face portrait is unclear and out of focus.',
  'core.idVerificationChecks.selfie_pose_detection.center_pose_face_obscured':
    "The center selfie's face appears obscured.",
  'core.idVerificationChecks.selfie_pose_detection.face_cropped':
    'The selfie does not capture the entire face.',
  'core.idVerificationChecks.selfie_pose_detection.face_quality':
    'The selfie captured is unclear and out of focus',
  'core.idVerificationChecks.selfie_pose_detection.face_too_far':
    'The selfie captured was too small.',
  'core.idVerificationChecks.selfie_pose_detection.missing_yaw_angles': 'Missing yaw angles.',
  'core.idVerificationChecks.selfie_pose_detection.pose_order_incorrect':
    'The submitted pose order was incorrect',
  'core.idVerificationChecks.selfie_pose_detection.required_poses_not_found':
    'The selfies appear to be incorrectly positioned in one or more poses.',
  'core.idVerificationChecks.selfie_pose_repeat_detection.poses_repeated':
    'The selfies appear to repeat across poses.',
  'core.idVerificationChecks.selfie_public_figure_detection.public_figure':
    'The selfie submission appears to be of a known public figure.',
  'core.idVerificationChecks.selfie_repeat_detection.repeat':
    'The selfie matches that of a previously submitted selfie on a different account.',
  'core.idVerificationChecks.selfie_repeat_detection.repeat_image':
    'The image matches that of a previously submitted selfie on a different account.',
  'core.idVerificationChecks.selfie_suspicious_entity_detection.suspicious_photo':
    'The selfie submission appears to be a government ID.',
  'core.idVerificationChecks.selfie_video_quality_detection.corrupt': 'The video is corrupt.',
  'core.idVerificationChecks.selfie_video_quality_detection.duration_too_short':
    'The duration of the video was too short.',
  'core.idVerificationChecks.selfie_video_quality_detection.low_bit_rate':
    'The bit rate is too low.',
  'core.idVerificationChecks.selfie_video_quality_detection.low_frame_rate':
    'The frame rate is too low.',
  'core.idVerificationChecks.selfie_video_quality_detection.not_found':
    'There was no video uploaded.',
  'core.idVerificationChecks.unknown': 'Unknown verification issue',
  'core.notifications.anchorLabels.appointmentCancelled': 'View Appointment',
  'core.notifications.anchorLabels.appointmentCompleted': 'View Appointment',
  'core.notifications.anchorLabels.appointmentConfirmed': 'View Appointment',
  'core.notifications.anchorLabels.appointmentDetailsHaveChanged': 'View Appointment',
  'core.notifications.anchorLabels.appointmentIsInProgressAtFacility': 'View Appointment',
  'core.notifications.anchorLabels.appointmentRequested': 'View Appointment',
  'core.notifications.anchorLabels.appointmentRescheduled': 'View Appointment',
  'core.notifications.anchorLabels.appointmentScheduled': 'View Appointment',
  'core.notifications.anchorLabels.appointmentTagged': 'View Appointment',
  'core.notifications.anchorLabels.assetReadyForPickup': 'View Appointment',
  'core.notifications.anchorLabels.missedAppointment': 'View Appointment',
  'core.notifications.anchorLabels.recurringAppointmentSeriesCreated': 'View Original Appointment',
  'core.notifications.anchorLabels.truckArrivedAtFacility': 'View Appointment',
  'core.notifications.contextLabels.assetReadyForPickup.amenitiesLabel': 'Amenities available',
  'core.notifications.contextLabels.assetReadyForPickup.appointmentDetailsLabel':
    'Appointment Details',
  'core.notifications.contextLabels.assetReadyForPickup.carrierContactLabel': 'Carrier Contact',
  'core.notifications.contextLabels.assetReadyForPickup.dockDoorLabel': 'Dock Door',
  'core.notifications.contextLabels.assetReadyForPickup.dockInstructionsLabel': 'Dock Instructions',
  'core.notifications.contextLabels.assetReadyForPickup.idLabel': 'Confirmation Number',
  'core.notifications.contextLabels.assetReadyForPickup.loadTypeLabel': 'Load Type',
  'core.notifications.contextLabels.assetReadyForPickup.noPickupScheduledLabel':
    'No pickup appointment scheduled',
  'core.notifications.contextLabels.assetReadyForPickup.openInGoogleMapsLabel':
    'Open in Google Maps',
  'core.notifications.contextLabels.assetReadyForPickup.ownedByLabel': 'Owned by:',
  'core.notifications.contextLabels.assetReadyForPickup.pickupScheduledForLabel':
    'Pickup scheduled for:',
  'core.notifications.contextLabels.assetReadyForPickup.ppeRequirementsLabel':
    'PPE & other requirements',
  'core.notifications.contextLabels.assetReadyForPickup.schedulingAnchorLabel': 'Schedule Pickup',
  'core.notifications.contextLabels.assetReadyForPickup.storeLabel': 'Store',
  'core.notifications.contextLabels.assetReadyForPickup.warehouseInstructionsLabel':
    'Warehouse Instructions',
  'core.notifications.descriptions.appointmentTagged':
    'Use Appointment Tags setting to enable tags individually',
  'core.notifications.meta.contentBlockDescription':
    'This content is placed below the confirmation/reference number and above the appointment details.',
  'core.notifications.meta.contentBlockTitle': 'Content Block',
  'core.notifications.subTitles.appointmentCancelled':
    'Please check all details and reason for cancellation.',
  'core.notifications.subTitles.appointmentCompleted':
    'Check the status and appointment details below.',
  'core.notifications.subTitles.appointmentConfirmed':
    'Please check location, date, time and all details below.',
  'core.notifications.subTitles.appointmentDetailsHaveChanged':
    'Please check location, date, time and all details below.',
  'core.notifications.subTitles.appointmentIsInProgressAtFacility':
    'Check the status and appointment details below.',
  'core.notifications.subTitles.appointmentRequested': 'Please wait for warehouse confirmation.',
  'core.notifications.subTitles.appointmentRescheduled':
    'Check the status and appointment details below.',
  'core.notifications.subTitles.appointmentScheduled':
    'Please check location, date, time and all details below.',
  'core.notifications.subTitles.appointmentTagged':
    'Please check the tag name and information below.',
  'core.notifications.subTitles.assetReadyForPickup':
    'An asset at your facility is ready for pickup.',
  'core.notifications.subTitles.missedAppointment': 'Carrier did not show for the appointment.',
  'core.notifications.subTitles.recurringAppointmentSeriesCreated':
    'Please check the details of the recurring appointment below.',
  'core.notifications.subTitles.truckArrivedAtFacility':
    'Check the status and appointment details below.',
  'core.notifications.subjects.appointmentCancelled':
    'Appointment cancelled with {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentCompleted':
    'Appointment completed at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentConfirmed':
    'Appointment confirmed at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentDetailsHaveChanged': 'Appointment details have changed',
  'core.notifications.subjects.appointmentIsInProgressAtFacility':
    'Appointment is in progress at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentRequested':
    'Appointment requested at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentRescheduled':
    'Appointment rescheduled at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentScheduled':
    'Appointment scheduled at {orgName} - {warehouseName}',
  'core.notifications.subjects.appointmentTagged':
    'Appointment tagged as {tagName} - {warehouseName}',
  'core.notifications.subjects.assetReadyForPickup':
    'Ready for Pickup - Container {containerNumber}',
  'core.notifications.subjects.missedAppointment':
    'Missed appointment at {orgName} - {warehouseName}',
  'core.notifications.subjects.recurringAppointmentSeriesCreated':
    'Recurring appointment series has been created',
  'core.notifications.subjects.truckArrivedAtFacility':
    'Truck arrived at {orgName} - {warehouseName}',
  'core.notifications.titles.appointmentCancelled': 'Appointment cancelled',
  'core.notifications.titles.appointmentCompleted': 'Appointment completed',
  'core.notifications.titles.appointmentConfirmed': 'Appointment confirmed',
  'core.notifications.titles.appointmentDetailsHaveChanged': 'Appointment details have changed',
  'core.notifications.titles.appointmentIsInProgressAtFacility':
    'Appointment is in progress at facility',
  'core.notifications.titles.appointmentRequested': 'Appointment requested',
  'core.notifications.titles.appointmentRescheduled': 'Appointment rescheduled',
  'core.notifications.titles.appointmentScheduled': 'Appointment scheduled',
  'core.notifications.titles.appointmentTagged': 'Appointment tagged',
  'core.notifications.titles.assetReadyForPickup': 'Asset ready for pickup',
  'core.notifications.titles.missedAppointment': 'Missed appointment',
  'core.notifications.titles.recurringAppointmentSeriesCreated':
    'Recurring appointment series created',
  'core.notifications.titles.truckArrivedAtFacility': 'Truck arrived at facility',
  'core.settings.defaultValues.referenceNumber': 'Reference Number',
  'core.settings.descriptions.aListOfMutedAppointmentNotifications':
    'A list of muted appointment notifications.',
  'core.settings.descriptions.additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx':
    'Additional information to help fill in the Reference Number field.  Eg: "Reference Number should start with OD-XX"',
  'core.settings.descriptions.additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeNumbersOnly':
    'Additional information to help fill in the unit type field. Eg: Unit Type should be numbers only.',
  'core.settings.descriptions.additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers':
    'Additional information to help fill in the unit type field. Eg: Unit Type should be only numbers',
  'core.settings.descriptions.allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal':
    'Allow Dock selection when booking an appointment in the Scheduling Portal',
  'core.settings.descriptions.appointmentNotificationsWillBeSent':
    'Appointment notifications will be sent',
  'core.settings.descriptions.appointmentNotificationsWillNOTBeSentBrStrongCautionStrongALLAppointmentNotificationsWillBeMutedForYourEntityForALLUsersIncludingCarriers':
    'Appointment notifications will <strong>NOT</strong> be sent.<br/><strong>Caution:</strong> ALL appointment notifications will be muted for your {entity} for ALL users including carriers.',
  'core.settings.descriptions.attributeToBeUsedForMatchingObservations':
    'Attribute to be used for matching observations',
  'core.settings.descriptions.autoDepartAssetsOnReceivingOutgateEvent':
    'Auto depart assets on receiving outgate event',
  'core.settings.descriptions.createAppointmentsEvenIfAppointmentValidationDoesNotPass':
    'Create appointments even if appointment validation does not pass',
  'core.settings.descriptions.determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports':
    'Determine how time will be displayed across the platform for all users of this Org, including the appointments grid and reports.',
  'core.settings.descriptions.emailAddressWhereTechnicalIssuesAndInformationWillBeSent':
    'Email address where technical issues and information will be sent',
  'core.settings.descriptions.enableTheCustomAppointmentStartTimesSetting':
    'Enable the custom appointment start times setting',
  'core.settings.descriptions.enableToSwitchToTheNewCustomizableAppointmentDetailsSystem':
    'Enable to switch to the new customizable appointment details system',
  'core.settings.descriptions.enforceBolSigningOnCheckOutForm':
    'Enforce BOL signing on check-out form',
  'core.settings.descriptions.errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut':
    'If the BOL is not available, the carrier will not be able to sign it, thus the check-out would be blocked. Here, you can set custom instructions that the driver will see in case this happens.',
  'core.settings.descriptions.includeHandlingUnitsFieldOnAllAppointmentForms':
    'Include Handling Units field on all appointment forms?',
  'core.settings.descriptions.personaTemplateUsedForCheckInIdentityVerification':
    'Persona template used for check-in identity verification',
  'core.settings.descriptions.preventCarriersFromReschedulingAppointmentsOptional':
    'Prevent carriers from rescheduling appointments. (optional)',
  'core.settings.descriptions.requireAtLeastThisAmountOfReferenceNumbersForAnAppointment':
    'Require at least this amount of reference numbers for an appointment',
  'core.settings.descriptions.requireAtMostThisAmountOfReferenceNumbersForAnAppointment':
    'Require at most this amount of reference numbers for an appointment',
  'core.settings.descriptions.requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn':
    'Require successful Persona validation before the driver can complete check-in',
  'core.settings.descriptions.requireTheHandlingUnitsFieldForAllAppointmentsBeingScheduled':
    'Require the Handling Units field for all appointments being scheduled',
  'core.settings.descriptions.requireTheReferenceNumberForAllAppointmentsBeingScheduled':
    'Require the Reference Number for all appointments being scheduled',
  'core.settings.descriptions.requireTheUnitTypeFieldForAllAppointmentsBeingScheduled':
    'Require the unit type field for all appointments being scheduled',
  'core.settings.descriptions.requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled':
    'Require unique Reference Numbers for all appointments being scheduled',
  'core.settings.descriptions.sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse':
    'Sends your Yard Map as a separate image message right after the check-in SMS. Requires a Yard Map to be uploaded for this warehouse.',
  'core.settings.descriptions.setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment':
    'Sets the maximum numeric value that can be entered for the Handling Units field on an appointment',
  'core.settings.descriptions.setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment':
    'Sets the minimum numeric value that can be entered for the Handling Units field on an appointment',
  'core.settings.descriptions.showThePersonaComponentInTheCheckInFlowForIdentityVerification':
    'Show the Persona component in the check-in flow for identity verification',
  'core.settings.descriptions.theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm':
    'The asset attribute the system will use to validate the check-out form',
  'core.settings.descriptions.theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId':
    'The display name for the Reference Number field. Eg: "PO Number", "Shipment ID"',
  'core.settings.descriptions.theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount':
    'The display name for the unit type field. Eg: Pallet Count, Skid Count',
  'core.settings.descriptions.theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal':
    'The duration is displayed on the Load Types select list booking an appointment in the Scheduling Portal',
  'core.settings.descriptions.theInputModeForTheReferenceNumberField':
    'The input mode for the reference number field',
  'core.settings.descriptions.theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn':
    'The number of minutes after the appointment start time that a carrier can check in',
  'core.settings.descriptions.theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn':
    'The number of minutes before the appointment start time that a carrier can check in',
  'core.settings.descriptions.theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime':
    'The number of minutes to account for an observation before and after the check-in time',
  'core.settings.descriptions.theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled':
    'The radius in miles that the driver must be within to check in. This is only applicable if geofencing is enabled.',
  'core.settings.descriptions.theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs':
    'The time between notifications sent to the technical contact when a validation server error occurs.',
  'core.settings.descriptions.thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart':
    'This is the interval minutes between when appointments can start',
  'core.settings.descriptions.thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage':
    'This message replaces the default check-in confirmation text sent to the driver by SMS. Leave blank to use the default message.',
  'core.settings.descriptions.thisOnlyAffectsNewlyCreatedAppointments':
    'This only affects newly created appointments',
  'core.settings.descriptions.thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse':
    'This setting asks for the drivers location and restricts them from checking-in when they are more than one mile away from your warehouse.',
  'core.settings.descriptions.thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted':
    "This setting will allow the choice of an alternate 'In Progress' status between 'Arrived' and 'Completed'",
  'core.settings.descriptions.userConfigurationOfHowGridTilesWillBeDisplayed':
    'User configuration of how grid tiles will be displayed.',
  'core.settings.descriptions.warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs':
    'Warehouse subscribers receive email notifications when an unplanned check-in occurs',
  'core.settings.descriptions.whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval':
    'When a carrier reschedules a Scheduled appointment, move it back to Requested for re-approval',
  'core.settings.descriptions.whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits':
    'When the limiter is 100% reached, this feature allows only warehouse users to override and create or approve appointments and units',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.customStartTimes':
    'Custom start times',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.everyQuarterOfTheHour001530And45':
    'Every quarter of the hour (:00, :15, :30, and :45)',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.everyTwentyMinutes0020And40':
    'Every Twenty Minutes (:00, :20, and :40)',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.topAndBottomOfTheHour00And30':
    'Top and bottom of the hour (:00 and :30)',
  'core.settings.dropdownOptions.allowAppointmentsForThisEntityToStartAt.topOfTheHour00':
    'Top of the hour (:00)',
  'core.settings.dropdownOptions.allowDockSelectionInSchedulingPortal.noDontAllowDockSelection':
    "No, don't allow Dock selection",
  'core.settings.dropdownOptions.allowDockSelectionInSchedulingPortal.yesAllowTheDockSelection':
    'Yes, allow the Dock selection',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.15Minutes': '15 Minutes',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.30Minutes': '30 Minutes',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.60Minutes': '60 Minutes',
  'core.settings.dropdownOptions.appointmentStartTimeInterval.90Minutes': '90 Minutes',
  'core.settings.dropdownOptions.checkInIdValidationTemplate.driverLicenseFace':
    'Driver License + Face',
  'core.settings.dropdownOptions.checkInIdValidationTemplate.driverLicenseFront1Retry':
    'Driver license - Front - 1 retry',
  'core.settings.dropdownOptions.checkInIdValidationTemplate.driverLicenseFrontBarcodeFaceUsOnly1Retry':
    'Driver license - Front, barcode, face, us only, 1 retry',
  'core.settings.dropdownOptions.checkInIdValidationTemplate.driverLicenseOnly':
    'Driver License Only',
  'core.settings.dropdownOptions.checkOutIdentifier.any': 'Any',
  'core.settings.dropdownOptions.checkOutIdentifier.licensePlate': 'License Plate',
  'core.settings.dropdownOptions.checkOutIdentifier.phoneNumber': 'Phone Number',
  'core.settings.dropdownOptions.displayTimeIn.militaryTime24Hour': 'Military time (24-hour)',
  'core.settings.dropdownOptions.displayTimeIn.regularTime12Hour': 'Regular time (12-hour)',
  'core.settings.dropdownOptions.enableAppointmentNotificationsForThisEntity.noDisableAppointmentNotifications':
    'No, disable appointment notifications',
  'core.settings.dropdownOptions.enableAppointmentNotificationsForThisEntity.yesEnableAppointmentNotifications':
    'Yes, enable appointment notifications',
  'core.settings.dropdownOptions.enableCheckInIdValidationPersona.no': 'No',
  'core.settings.dropdownOptions.enableCheckInIdValidationPersona.yes': 'Yes',
  'core.settings.dropdownOptions.hideTheLoadTypeDuration.noDontHideTheLoadTypeDuration':
    "No, don't hide the Load Type duration",
  'core.settings.dropdownOptions.hideTheLoadTypeDuration.yesHideTheLoadTypeDuration':
    'Yes, hide the Load Type duration',
  'core.settings.dropdownOptions.includeHandlingUnitsFieldOnAllAppointmentForms.noDontIncludeTheHandlingUnitsField':
    "No, don't include the Handling Units field",
  'core.settings.dropdownOptions.includeHandlingUnitsFieldOnAllAppointmentForms.yesIncludeTheHandlingUnitsField':
    'Yes, include the Handling Units field',
  'core.settings.dropdownOptions.includeReferenceNumberFieldOnAllAppointmentForms.noDontIncludeTheReferenceNumberField':
    "No, don't include the Reference Number field",
  'core.settings.dropdownOptions.includeReferenceNumberFieldOnAllAppointmentForms.yesIncludeTheReferenceNumberField':
    'Yes, include the Reference Number field',
  'core.settings.dropdownOptions.makeHandlingUnitsARequiredField.noDontMakeHandlingUnitsARequiredField':
    "No, don't make Handling Units a required field",
  'core.settings.dropdownOptions.makeHandlingUnitsARequiredField.yesMakeHandlingUnitsARequiredField':
    'Yes, make Handling Units a required field',
  'core.settings.dropdownOptions.makeReferenceNumberARequiredField.noDontMakeReferenceNumberARequiredField':
    "No, don't make Reference Number a required field",
  'core.settings.dropdownOptions.makeReferenceNumberARequiredField.yesMakeReferenceNumberARequiredField':
    'Yes, make Reference Number a required field',
  'core.settings.dropdownOptions.observationMatchAttribute.any': 'Any',
  'core.settings.dropdownOptions.observationMatchAttribute.cascade': 'Cascade',
  'core.settings.dropdownOptions.observationMatchAttribute.dotNumber': 'DOT Number',
  'core.settings.dropdownOptions.observationMatchAttribute.licensePlate': 'License Plate',
  'core.settings.dropdownOptions.preventReschedulingAppointmentsInTheSchedulingPortal.allowReschedulingInTheSchedulingPortal':
    'Allow rescheduling in the Scheduling Portal ',
  'core.settings.dropdownOptions.preventReschedulingAppointmentsInTheSchedulingPortal.preventReschedulingInTheSchedulingPortal':
    'Prevent rescheduling in the Scheduling Portal',
  'core.settings.dropdownOptions.receiveUnplannedCheckInEmailNotifications.no': 'No',
  'core.settings.dropdownOptions.receiveUnplannedCheckInEmailNotifications.yes': 'Yes',
  'core.settings.dropdownOptions.referenceNumberInputMode.alphanumeric': 'Alphanumeric',
  'core.settings.dropdownOptions.referenceNumberInputMode.numeric': 'Numeric',
  'core.settings.dropdownOptions.requireCheckInIdValidationToCompleteCheckIn.no': 'No',
  'core.settings.dropdownOptions.requireCheckInIdValidationToCompleteCheckIn.yes': 'Yes',
  'core.settings.dropdownOptions.requireUniqueReferenceNumbers.noDontRequireUniqueReferenceNumbers':
    "No, don't require unique Reference Numbers",
  'core.settings.dropdownOptions.requireUniqueReferenceNumbers.yesRequireUniqueReferenceNumbers':
    'Yes, require unique Reference Numbers',
  'core.settings.dropdownOptions.revertToRequestedOnCarrierReschedule.keepStatusUnchangedOnCarrierReschedule':
    'Keep status unchanged on carrier reschedule',
  'core.settings.dropdownOptions.revertToRequestedOnCarrierReschedule.revertToRequestedOnCarrierReschedule':
    'Revert to Requested on carrier reschedule',
  'core.settings.dropdownOptions.statusForNewlyCreatedAppointments.requested': 'Requested',
  'core.settings.dropdownOptions.statusForNewlyCreatedAppointments.scheduled': 'Scheduled',
  'core.settings.dropdownOptions.theStatusThatFollowsArrivedIs.completed': 'Completed',
  'core.settings.dropdownOptions.theStatusThatFollowsArrivedIs.inProgress': 'In Progress',
  'core.settings.examples.displayTimeIn.eG07001900': 'E.g. 07:00 / 19:00',
  'core.settings.examples.displayTimeIn.eG700Am700Pm': 'E.g. 7:00 AM / 7:00 PM',
  'core.settings.groupDescriptions.determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart':
    'Determine the time intervals at which appointments will be allowed to start.',
  'core.settings.groupDescriptions.handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature':
    'Handling Units is a numeric field for requesting units (e.g. pallets) during appointment scheduling. Add it to your form to also enable the Limiter feature.',
  'core.settings.groupDescriptions.manageAllTypesOfAppointmentNotificationsForThisEntity':
    'Manage all types of appointment notifications for this {entity}.',
  'core.settings.groupDescriptions.manageTheSchedulingPortalSettingsForThisEntity':
    'Manage the Scheduling Portal settings for this {entity}',
  'core.settings.groupDescriptions.referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment':
    "Reference Number is the reference you can request from carriers when they're scheduling an appointment.",
  'core.settings.groupDescriptions.theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay':
    'The Limiter allows you to set a maximum number of appointments or handling units (e.g. pallets) that can be scheduled per day.',
  'core.settings.groups.appointmentNotifications': 'Appointment Notifications',
  'core.settings.groups.appointmentStartTimes': 'Appointment Start Times',
  'core.settings.groups.appointmentStatuses': 'Appointment Statuses',
  'core.settings.groups.appointmentValidation': 'Appointment Validation',
  'core.settings.groups.customAppointmentsGrid': 'Custom Appointments Grid',
  'core.settings.groups.dockSelection': 'Dock Selection',
  'core.settings.groups.gateManagement': 'Gate Management',
  'core.settings.groups.handlingUnits': 'Handling Units',
  'core.settings.groups.idValidation': 'ID Validation',
  'core.settings.groups.limiter': 'Limiter',
  'core.settings.groups.other': 'Other',
  'core.settings.groups.referenceNumber': 'Reference Number',
  'core.settings.groups.schedulingPortal': 'Scheduling Portal',
  'core.settings.groups.smartGate': 'SmartGate',
  'core.settings.groups.timeDisplay': 'Time Display',
  'core.settings.labels.allowAppointmentsForThisEntityToStartAt':
    'Allow appointments for this {entity} to start at:',
  'core.settings.labels.allowDockSelectionInSchedulingPortal':
    'Allow Dock selection in Scheduling Portal?',
  'core.settings.labels.appointmentStartTimeInterval': 'Appointment Start Time Interval',
  'core.settings.labels.autoDepartAssets': 'Auto depart Assets',
  'core.settings.labels.checkInEarlyThreshold': 'Check-in Early Threshold',
  'core.settings.labels.checkInIdValidationTemplate': 'Check-in ID validation template',
  'core.settings.labels.checkInLateThreshold': 'Check-in Late Threshold',
  'core.settings.labels.checkOutBolNotLoadingErrorMessage':
    'Check-out BOL not loading error message',
  'core.settings.labels.checkOutBolSignedRequired': 'Check-out BOL Signed Required',
  'core.settings.labels.checkOutIdentifier': 'Check-out Identifier',
  'core.settings.labels.createAppointmentOnExternalValidationFailure':
    'Create appointment on external validation failure',
  'core.settings.labels.customizeAppointmentDetails': 'Customize appointment details',
  'core.settings.labels.customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional':
    'Customize the first SMS message drivers receive after check-in (optional)',
  'core.settings.labels.displayTimeIn': 'Display time in:',
  'core.settings.labels.driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment':
    'Drivers can only check in if the reference number matches the scheduled appointment',
  'core.settings.labels.driversMustEnterAReferenceNumberToCheckIn':
    'Drivers must enter a reference number to check in',
  'core.settings.labels.enableAppointmentNotificationsForThisEntity':
    'Enable appointment notifications for this {entity}?',
  'core.settings.labels.enableCheckInIdValidationPersona':
    'Enable check-in ID validation (Persona)',
  'core.settings.labels.enableCustomAppointmentStartTimes': 'Enable Custom Appointment Start Times',
  'core.settings.labels.enableOverrideLimiterFunction': 'Enable Override Limiter Function',
  'core.settings.labels.enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation':
    'Enforce geofencing to require drivers to provide their real time location',
  'core.settings.labels.geofenceRadius': 'Geofence Radius',
  'core.settings.labels.gridTileConfig': 'Grid tile config',
  'core.settings.labels.handlingUnitsHelperText': 'Handling Units Helper Text',
  'core.settings.labels.handlingUnitsLabel': 'Handling Units Label',
  'core.settings.labels.hideTheLoadTypeDuration': 'Hide the load type duration?',
  'core.settings.labels.includeHandlingUnitsFieldOnAllAppointmentForms':
    'Include Handling Units field on all appointment forms?',
  'core.settings.labels.includeReferenceNumberFieldOnAllAppointmentForms':
    'Include Reference Number field on all appointment forms?',
  'core.settings.labels.includeYardMapImageInTheFirstCheckInSms':
    'Include Yard Map image in the first check-in SMS?',
  'core.settings.labels.makeHandlingUnitsARequiredField': 'Make Handling Units a required field?',
  'core.settings.labels.makeReferenceNumberARequiredField':
    'Make Reference Number a required field?',
  'core.settings.labels.maximumAmountOfReferenceNumbers': 'Maximum Amount of Reference Numbers',
  'core.settings.labels.maximumHandlingUnitsValueForAnAppointment':
    'Maximum Handling Units value for an appointment',
  'core.settings.labels.minimumAmountOfReferenceNumbers': 'Minimum Amount of Reference Numbers',
  'core.settings.labels.minimumHandlingUnitsValueForAnAppointment':
    'Minimum Handling Units value for an appointment',
  'core.settings.labels.muteAppointmentNotifications': 'Mute Appointment Notifications',
  'core.settings.labels.observationMatchAttribute': 'Observation Match Attribute',
  'core.settings.labels.observationMatchTimeWindow': 'Observation Match Time Window',
  'core.settings.labels.preventReschedulingAppointmentsInTheSchedulingPortal':
    'Prevent rescheduling appointments in the Scheduling Portal?',
  'core.settings.labels.receiveUnplannedCheckInEmailNotifications':
    'Receive Unplanned Check-in Email Notifications',
  'core.settings.labels.referenceNumberFieldName': 'Reference Number field name',
  'core.settings.labels.referenceNumberHelperText': 'Reference Number helper text',
  'core.settings.labels.referenceNumberInputMode': 'Reference Number Input Mode',
  'core.settings.labels.requireCheckInIdValidationToCompleteCheckIn':
    'Require check-in ID validation to complete check-in',
  'core.settings.labels.requireUniqueReferenceNumbers': 'Require Unique Reference Numbers',
  'core.settings.labels.revertToRequestedOnCarrierReschedule':
    'Revert to Requested on carrier reschedule',
  'core.settings.labels.selectEachDesiredStartTimeIndividually':
    'Select each desired start time individually',
  'core.settings.labels.statusForNewlyCreatedAppointments': 'Status for newly created appointments',
  'core.settings.labels.technicalContactEmailAddress': 'Technical Contact Email Address',
  'core.settings.labels.technicalContactEmailThrottleMinutes':
    'Technical Contact Email Throttle Minutes',
  'core.settings.labels.theStatusThatFollowsArrivedIs': "The status that follows 'Arrived' is",
  'core.settings.labels.uploadWarehouseYardMap':
    'Upload your warehouse yard map to display it in the Scheduling Portal',
  'core.settings.labels.uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications':
    'Upload your {entity} logo to display it in the Scheduling Portal and in all email notifications',
  'core.settings.labels.uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal':
    'Upload your warehouse yard map to display it in the Scheduling Portal',
  'core.settings.labels.wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional':
    'Would you like to show additional information to the drivers after they check in? (optional)',
  'core.settings.messages.leavingThisFieldEmptyWillResultInNoAvailabilityOnTheSchedule':
    'Leaving this field empty will result in no availability on the schedule.',
  'core.settings.modalText.youCanUseTheZoomFeatureAndDragTheImageToAdjustHowThePreviewWillAppearForTheSchedulingUsersTheyWillBeAbleToClickThePreviewToSeeTheFullImage':
    'You can use the zoom feature and drag the image to adjust how the preview will appear for the scheduling users. They will be able  to click the preview to see the full image.',
  'core.settings.notes.enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually':
    'Enabling this option does not impact notifications that are already disabled on the appointment level individually.',
  'core.settings.notes.ifEmptyTheDefaultNameWillBeApplied':
    'If empty, the default name will be applied',
  'core.settings.notes.ifLeftEmptyNoNotificationsWillBeSent':
    'If left empty, no notifications will be sent',
  'core.settings.notes.ifLeftEmptyTheDefaultHelperTextWillBeApplied':
    'If left empty, the default helper text will be applied',
  'core.settings.notes.ifLeftEmptyTheDefaultNameWillBeApplied':
    'If left empty, the default name will be applied',
  'core.settings.notes.notesPrefix': 'Note:',
  'core.settings.notes.referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments':
    'Reference number assigned to cancelled or no show appointments may be reused on new appointments',
  'core.settings.placeholders.insertMessageHere': 'Insert message here',
  'core.settings.placeholders.referenceNumberAssociatedWithAppointment':
    'Reference Number associated with appointment',
  'core.settings.sectionLabels.checkInSms': 'Check-in SMS',
  'core.settings.sectionLabels.drivers': 'Drivers',
  'core.user.descriptions.allPermissionsAndFullControlOverAllAccounts':
    'All permissions and full control over all accounts.',
  'core.user.descriptions.allPermissionsAndFullControlOverTheOrganizationAccount':
    'All permissions and full control over the Organization account.',
  'core.user.descriptions.baseUserAccount': 'Base user account.',
  'core.user.descriptions.carrierAdministrator': 'Carrier administrator.',
  'core.user.descriptions.carrierUser': 'Carrier user',
  'core.user.descriptions.createEditCancelAppointments': 'Create/edit/cancel Appointments.',
  'core.user.descriptions.createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners':
    'Create/edit/delete Appointments, Warehouses, Load Types, Docks, and Users (except Owners).',
  'core.user.descriptions.editAppointmentStatusTagsAndSubscribers':
    'Edit Appointment Status, tags, and subscribers.',
  'core.user.descriptions.godRoleWithLessControl': 'GOD role with less control.',
  'core.user.descriptions.viewOnlyNoCreateOrEditActionsAllowed':
    'View only. No create or edit actions allowed.',
  'core.user.descriptions.warehouseDriverHasLimitedAccessToTheApplication':
    'Warehouse driver, has limited access to the application.',
  'core.user.errors.mustContainAtLeastOneLetter': 'Must contain at least one letter',
  'core.user.errors.mustContainAtLeastOneNumber': 'Must contain at least one number',
  'core.user.errors.mustContainAtLeastOneSpecialCharacter':
    'Must contain at least one special character',
  'core.user.errors.mustContainUpperCaseAndLowerCase': 'Must contain upper-case and lower-case',
  'core.user.errors.mustHaveAtLeast8Characters': 'Must have at least 8 characters',
  'core.user.errors.yourRoleDoesNotAllowThisAction': 'Your role does not allow you to {action}',
  'core.user.errors.yourRoleDoesNotAllowYouToPerformThisAction':
    'Your role does not allow you to perform this action',
  'core.yard.altAssetVisitTypes.drop': 'Drop',
  'core.yard.altAssetVisitTypes.dropHook': 'Drop & Hook',
  'core.yard.altAssetVisitTypes.live': 'Live',
  'core.yard.altAssetVisitTypes.liveLoad': 'Live Load',
  'core.yard.altAssetVisitTypes.liveUnload': 'Live Unload',
  'core.yard.altAssetVisitTypes.pickUp': 'Pick Up',
  'core.yard.altAssetVisitTypes.unknown': 'Unknown',
  'core.yard.assetContainerEvent.types.arrived': 'Arrived',
  'core.yard.assetContainerEvent.types.arrivedWaiting': 'Arrived/Waiting',
  'core.yard.assetContainerEvent.types.departed': 'Departed',
  'core.yard.assetContainerEvent.types.inTransit': 'In Transit',
  'core.yard.assetContainerEvent.types.inoperable': 'Inoperable',
  'core.yard.assetContainerEvent.types.loading': 'Loading',
  'core.yard.assetContainerEvent.types.loadingComplete': 'Loading Complete',
  'core.yard.assetContainerEvent.types.missing': 'Missing',
  'core.yard.assetContainerEvent.types.readyForPickup': 'Ready for Pickup',
  'core.yard.assetContainerEvent.types.unloading': 'Unloading',
  'core.yard.assetContainerEvent.types.unloadingComplete': 'Unloading Complete',
  'core.yard.assetContainerStates.empty': 'Empty',
  'core.yard.assetContainerStates.full': 'Full',
  'core.yard.assetContainerStates.partiallyLoaded': 'Partially Loaded',
  'core.yard.assetContainerTypes.chassis': 'Chassis',
  'core.yard.assetContainerTypes.container': 'Container',
  'core.yard.assetContainerTypes.other': 'Other',
  'core.yard.assetContainerTypes.oversized': 'Oversized',
  'core.yard.assetContainerTypes.reefer': 'Reefer',
  'core.yard.assetContainerTypes.trailer': 'Trailer',
  'core.yard.assetVisitDirections.inbound': 'Inbound',
  'core.yard.assetVisitDirections.inboundAndOutbound': 'In & Out',
  'core.yard.assetVisitDirections.outbound': 'Outbound',
  'core.yard.assetVisitTypes.drop': 'Drop',
  'core.yard.assetVisitTypes.dropHook': 'Drop & Hook',
  'core.yard.assetVisitTypes.live': 'Live',
  'core.yard.assetVisitTypes.pickup': 'Hook',
  'core.yard.assetVisitYardEvent.Appointment Linked': 'Appointment Linked',
  'core.yard.assetVisitYardEvent.Appointment Unlinked': 'Appointment Unlinked',
  'core.yard.assetVisitYardEvent.Arrived': 'Arrived',
  'core.yard.assetVisitYardEvent.Docked': 'Docked',
  'core.yard.assetVisitYardEvent.Dropped': 'Dropped',
  'core.yard.assetVisitYardEvent.Hooked': 'Hooked',
  'core.yard.assetVisitYardEvent.Parked': 'Parked',
  'core.yard.assetVisitYardEvent.Status Updated': 'Status Update',
  'core.yard.assetVisitYardEvent.Unassigned': 'Unassigned',
  'core.yard.labels.dotNumber': 'DOT Number',
  'core.yard.labels.driversPhoneNumber': "Driver's Phone Number",
  'core.yard.labels.licensePlate': 'License Plate',
  'core.yard.labels.visitType': 'Visit Type',
  'core.yard.loadTypeDirections.inOut': 'Inbound/Outbound',
  'core.yard.loadTypeDirections.inbound': 'Inbound',
  'core.yard.loadTypeDirections.outbound': 'Outbound',
  'core.yard.messages.awaitingArrival': 'Awaiting arrival',
  'core.yard.messages.blockedUntilSpotIsOpen': 'Blocked until {spot} is open',
  'core.yard.messages.failedToLoadSpotDetails': 'Failed to load spot details',
  'core.yard.messages.noInformationAvailable': 'No information available',
  'core.yard.messages.noVisitFound': 'No visit found',
  'core.yard.messages.notInformed': 'Not informed',
  'core.yard.messages.retry': 'Retry',
  'core.yard.messages.spotIsEmpty': 'Spot is empty',
  'core.yard.messages.syncing': 'Syncing',
  'core.yard.messages.unhooked': 'Unhooked',
  'core.yard.messages.unknownCompany': 'Unknown Company',
  'core.yard.messages.waitingAssignment': 'Waiting assignment',
  'core.yard.spotStatuses.assigned': 'assigned',
  'core.yard.spotStatuses.closed': 'closed',
  'core.yard.spotStatuses.open': 'open',
  'core.yard.spotStatuses.reservedAutomated': 'reserved',
  'core.yard.spotStatuses.reservedManual': 'reserved',
  'core.yard.spotStatuses.unknown': 'unknown',
  'core.yard.spotTypes.docking': 'docking',
  'core.yard.spotTypes.parking': 'parking'
};
